module.exports = __webpack_public_path__ + "assets/img/img_2025.d459d803.png";